import { useQuery } from '@tanstack/react-query'
import { usersApi } from '@/api/users'
import { useTenantKey } from './useTenantKey'

const ROLES_KEY = ['roles'] as const

export function useAllUsers() {
  const tenantKey = useTenantKey()

  return useQuery({
    queryKey: tenantKey('users'),
    queryFn: usersApi.getAll,
  })
}

export function useRoles() {
  return useQuery({
    queryKey: ROLES_KEY,
    queryFn: usersApi.getRoles,
  })
}
